var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWind(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 96 96",
    enableBackground: "new 0 0 96 96",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Base",
    display: "none"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Dibujo"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M54,46l-30.001-0.001c-1.104,0-2,0.896-2,2s0.896,2,2,2L54,50c3.859,0,7,3.141,7,7s-3.141,7-7,7c-1.105,0-2,0.896-2,2 s0.895,2,2,2c6.065,0,11-4.935,11-11S60.065,46,54,46z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.999,52H24c-1.104,0-2,0.896-2,2s0.896,2,2,2h23.999c0.552,0,1,0.448,1,1s-0.448,1-1,1c-1.105,0-2,0.896-2,2 s0.895,2,2,2c2.757,0,5-2.243,5-5S50.756,52,47.999,52z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69,38c-1.104,0-2,0.896-2,2s0.896,2,2,2c0.552,0,1,0.448,1,1s-0.448,1-1,1h-4c-1.105,0-2,0.896-2,2s0.895,2,2,2h4 c2.757,0,5-2.243,5-5S71.757,38,69,38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.999,43.999L57,44c4.411,0,8-3.589,8-8s-3.589-8-8-8s-8,3.589-8,8c0,1.104,0.895,2,2,2c1.104,0,2-0.896,2-2 c0-2.206,1.794-4,4-4c2.206,0,4,1.794,4,4s-1.794,4-4,4l-33.001-0.001c-1.104,0-2,0.896-2,2S22.895,43.999,23.999,43.999z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWind);
export default __webpack_public_path__ + "static/media/Wind.2e943aa4c996e8d438e551d172ba1ed5.svg";
export { ForwardRef as ReactComponent };